// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32gzE","colMin":"styles_colMin__1bMk9"};